import React, { Component } from 'react';
import axios from 'axios';

import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavbarToggler,
  MDBCollapse,
  MDBNavItem,
  MDBFooter,
  MDBNavLink
  //MDBTooltip,
  //MDBIcon
} from 'mdbreact';
import { ReactComponent as Logo } from './assets/logo.svg';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './Routes';

class App extends Component {
  state = {
            collapseID: ''
          };


    //Evento para destruuir session
    // acceder(event){
    //   event.preventDefault();      
    
    //   axios.get('http://10.10.5.58:8081/boletapdf/'+this.props.location.state.user+'/122019/'+ this.state.valor+'')    
    //       .then((response) => this.setState({ boletapdf : response.data}))
    //       .catch()                                           
    // }
    //Fin destruuir session

  toggleCollapse = collapseID => () =>
    this.setState(prevState => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : ''
    }));

  closeCollapse = collapseID => () => {
    //Destruir sesion          
      axios.get('http://remuneraciones.unsaac.edu.pe:3001/borrarsesion/')    
          .then((response) => this.setState({ collapseID : ''}))
          .catch()                                           
    //Fin destruir sesion    

    window.scrollTo(0, 0);
    this.state.collapseID === collapseID && this.setState({ collapseID: '' });
  };

  render() {
    const overlay = (
      <div
        id='sidenav-overlay'
        style={{ backgroundColor: 'transparent' }}
        onClick={this.toggleCollapse('mainNavbarCollapse')}
      />
    );

    const { collapseID } = this.state;

    return (
      <Router basename={'/remuneraciones'}>
        <div className='flyout'>
          <MDBNavbar color='black' dark expand='md' fixed='top' scrolling>
            <MDBNavbarBrand href='/' className='py-0 font-weight-bold'>
              <Logo style={{ height: '2.5rem', width: '2.5rem' }} />
              <strong className='align-middle'>Centro de computo - unsaac</strong>
            </MDBNavbarBrand>
            <MDBNavbarToggler
              onClick={this.toggleCollapse('mainNavbarCollapse')}
            />
            <MDBCollapse
              id='mainNavbarCollapse'
              isOpen={this.state.collapseID}
              navbar
            >
              <MDBNavbarNav right>
                <MDBNavItem>
                  <MDBNavLink
                    exact
                    to='/'
                    onClick={this.closeCollapse('mainNavbarCollapse')}
                  >
                    <strong>Inicio</strong>
                  </MDBNavLink>
                </MDBNavItem>
                {/*
                <MDBNavItem>
                  <MDBNavLink
                    onClick={this.closeCollapse('mainNavbarCollapse')}
                    to='/css'
                  >
                    <strong>CSS</strong>
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink
                    onClick={this.closeCollapse('mainNavbarCollapse')}
                    to='/components'
                  >
                    <strong>Components</strong>
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink
                    onClick={this.closeCollapse('mainNavbarCollapse')}
                    to='/advanced'
                  >
                    <strong>Advanced</strong>
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink
                    onClick={this.closeCollapse('mainNavbarCollapse')}
                    to='/navigation'
                  >
                    <strong>Navigation</strong>
                  </MDBNavLink>
                </MDBNavItem>
                */}                
                <MDBNavItem>
                  <MDBNavLink className='green-text' onClick={this.closeCollapse('mainNavbarCollapse')} to='/FormularioEscolaridad'>
                    <strong>Formulario Aguinaldo</strong>
                  </MDBNavLink>
                </MDBNavItem>

                <MDBNavItem>
                  <MDBNavLink onClick={this.closeCollapse('mainNavbarCollapse')} to='/contrasenaCrear'>
                    <strong>CrearContraseña</strong>
                  </MDBNavLink>
                </MDBNavItem>

                <MDBNavItem>
                  <MDBNavLink onClick={this.closeCollapse('mainNavbarCollapse')} to='/contrasena'>
                    <strong>CambiarContraseña</strong>
                  </MDBNavLink>
                </MDBNavItem>

                <MDBNavItem>
                  <MDBNavLink
                    onClick={this.closeCollapse('mainNavbarCollapse')}
                    to='/'
                  >
                    <strong>Salir</strong>
                  </MDBNavLink>
                </MDBNavItem>
                {/*
                <MDBNavItem>
                  <MDBNavLink
                    onClick={this.closeCollapse('mainNavbarCollapse')}
                    to='/tables'
                  >
                    <strong>Tables</strong>
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink
                    onClick={this.closeCollapse('mainNavbarCollapse')}
                    to='/modals'
                  >
                    <strong>Modals</strong>
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBNavLink
                    onClick={this.closeCollapse('mainNavbarCollapse')}
                    to='/addons'
                  >
                    <strong>Addons</strong>
                  </MDBNavLink>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBTooltip placement='bottom' domElement style={{ display: "block" }}>
                    <a 
                      className='nav-link Ripple-parent' 
                      href='https://mdbootstrap.com/products/react-ui-kit/'
                      target='_blank'
                      rel="noopener noreferrer" 
                    >
                      <strong><MDBIcon far icon="gem" /></strong>
                    </a>
                    <span>PRO</span>
                  </MDBTooltip>
                </MDBNavItem>
                <MDBNavItem>
                  <MDBTooltip placement='bottom' domElement style={{ display: "block" }}>
                    <a 
                      className='nav-link Ripple-parent' 
                      href='https://mdbootstrap.com/docs/react/getting-started/download/'
                      target='_blank'
                      rel="noopener noreferrer" 
                    >
                      <strong><MDBIcon icon="download" /></strong>
                    </a>
                    <span>FREE</span>
                  </MDBTooltip>
                </MDBNavItem>
              */}
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBNavbar>
          {collapseID && overlay}
          <main style={{ marginTop: '4rem' }}>
            <Routes />
          </main>
          <MDBFooter color='black'>
            <p className='footer-copyright mb-0 py-3 text-center'>
              &copy; {new Date().getFullYear()} Copyright:
              <a href='https://www.unsaac.edu.pe'> unsaac.edu.pe </a>
            </p>
          </MDBFooter>
        </div>
      </Router>
    );
  }
}

export default App;
